export const GET_GENRE_VIBES = gql`
  query GetGenreVibes($type: GenreVibeType) {
    genreVibes(type: $type) {
      id
      name
      slug
      type
    }
  }
`

export const GET_GENRES = gql`
  query GetGenres {
    genreVibes(type: GENRE) {
      id
      slug
      name
      type
    }
  }
`

export const GET_NORMALIZED_SHOW = gql`
  query GetNormalizedShow(
    $id: String!
    $stationId: UUID
    $country: CountryCode
  ) {
    normalizedShow(id: $id, stationId: $stationId, country: $country) {
      contentRating
      createdAt
      descriptionShort
      descriptionLong
      genreVibes {
        id
        name
        slug
        type
      }
      genre {
        id
        name
        slug
        type
      }
      images {
        image
        profile
      }
      isAvailable
      isNotAvailableReason
      language
      passportLevel
      productionLocale
      runtime
      seasons {
        seasonNumber
        episodeCount
      }
      showType
      slug
      title
      updatedAt
    }
  }
`

export const GET_NORMALIZED_VIDEO = gql`
  query GetNormalizedVideo(
    $id: String!
    $stationId: UUID
    $country: CountryCode
  ) {
    normalizedVideo(id: $id, stationId: $stationId, country: $country) {
      availabilities {
        ALL_MEMBERS {
          countries
          end
          isAvailable
          isNotAvailableReason
          start
        }
        PUBLIC {
          countries
          end
          isAvailable
          isNotAvailableReason
          start
        }
        STATION_MEMBERS {
          countries
          end
          isAvailable
          isNotAvailableReason
          start
        }
      }
      createdAt
      duration
      episodeNumber
      funderMessage
      id
      images {
        image
        profile
      }
      isAvailable
      isNotAvailableReason
      normalizedShow(stationId: $stationId, country: $country) {
        id
        title
      }
      season
      skipSponsorship
      slug
      videoType
      updatedAt
    }
  }
`

export const GET_STATION_BRANDING = gql`
  query GetStationBranding($callSign: String!) {
    station(callSign: $callSign) {
      callSign
      colorBackground
      colorPrimary
      colorSecondary
      email
      isLocalPublicMember
      logoPrimarySmall: image(profile: "station-logo-primary") {
        image(transforms: { height: 49 })
      }
      logoColorLarge: image(profile: "station-color-logo") {
        image(transforms: { width: 256 })
      }
      logoWhiteSmall: image(profile: "station-white-logo") {
        image(transforms: { height: 49 })
      }
      name
      phone
      urls
    }
  }
`

export const SEARCH_SHOWS = gql`
  query SearchShows(
    $search: String!
    $stationId: UUID
    $filters: FilterShowInput
  ) {
    searchShows(search: $search, stationId: $stationId, filters: $filters) {
      createdAt
      descriptionLong
      genreVibes {
        id
        name
        type
      }
      hasSubtitles
      id
      images {
        image
        profile
      }
      isAvailable
      poster: image(profile: "show-poster2x3") {
        image(transforms: { height: 220 })
      }
      productionLocale
      showType
      title
      updatedAt
      videoTotals {
        total
      }
    }
  }
`

export const SEARCH_NORMALIZED_SHOWS = gql`
  query SearchNormalizedShows(
    $search: String!
    $stationId: UUID
    $filters: FilterShowInput
  ) {
    searchNormalizedShows(
      search: $search
      stationId: $stationId
      filters: $filters
    ) {
      normalizedShows {
        createdAt
        descriptionLong
        genreVibes {
          id
          name
          type
        }
        hasSubtitles
        id
        images {
          image
          profile
        }
        productionLocale
        showType
        title
        updatedAt
        videoTotals {
          total
        }
      }
      offset
      total
    }
  }
`

export const SEARCH_VIDEOS = gql`
  query SearchVideos(
    $search: String!
    $stationId: UUID
    $filters: FilterVideoInput
  ) {
    searchVideos(search: $search, stationId: $stationId, filters: $filters) {
      availabilities {
        ALL_MEMBERS {
          end
          isAvailable
          start
        }
        PUBLIC {
          end
          isAvailable
          start
        }
        STATION_MEMBERS {
          end
          isAvailable
          start
        }
      }
      contentRating
      episodeNumber
      id
      images {
        image
        profile
      }
      isAvailable
      normalizedShow(stationId: $stationId) {
        title
      }
      season
      title
      updatedAt
      videoType
    }
  }
`

export const SEARCH_NORMALIZED_VIDEOS = gql`
  query SearchNormalizedVideos(
    $search: String!
    $stationId: UUID
    $filters: FilterVideoInput
  ) {
    searchNormalizedVideos(
      search: $search
      stationId: $stationId
      filters: $filters
    ) {
      normalizedVideos {
        availabilities {
          ALL_MEMBERS {
            end
            isAvailable
            start
          }
          PUBLIC {
            end
            isAvailable
            start
          }
          STATION_MEMBERS {
            end
            isAvailable
            start
          }
        }
        contentRating
        descriptionLong
        episodeNumber
        id
        images {
          image
          profile
        }
        isAvailable
        normalizedShow(stationId: $stationId) {
          title
        }
        season
        title
        updatedAt
        videoType
      }
      offset
      total
    }
  }
`
